import { render } from "./performance.section.html?vue&type=template&id=460db76d&scoped=true&lang=html&external"
import script from "./performance.section.vue?vue&type=script&lang=js"
export * from "./performance.section.vue?vue&type=script&lang=js"

import "./_performance.section.mobile.scss?vue&type=style&index=0&id=460db76d&lang=scss&scoped=true&external"
import "./_performance.section.desktop.scss?vue&type=style&index=1&id=460db76d&lang=scss&scoped=true&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-460db76d"]])

export default __exports__